import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';

import { Observable, map } from 'rxjs';

import {
  CACHE_MANAGER_WRAP,
  CacheManagerWrapObservable,
  SERVER_RESPONSE,
  ServerResponse
} from '../server/server.tokens';

import { TransferHttpResponse, createHttpResponse, getRequestCacheParams, serializeHttpResponse } from './http.helpers';

/**
 * On server side, the interceptor retrieves cached responses from Node CacheManager based on
 * - HttpContextToken `RESPONSE_CACHE_TTL` for regular Http requests
 * - HttpRequest header `gql-response-cache-ttl` for GraphQL requests
 */
@Injectable()
export class HttpServerCacheInterceptor implements HttpInterceptor {
  private readonly cacheEnabled: boolean;
  constructor(
    @Optional() @Inject(CACHE_MANAGER_WRAP) private readonly wrap$: CacheManagerWrapObservable<TransferHttpResponse>,
    @Optional() @Inject(SERVER_RESPONSE) response: ServerResponse
  ) {
    this.cacheEnabled = this.wrap$ && !response?.locals.skipDataCache;
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const [req, ttl, cacheKey] = getRequestCacheParams(request);
    const next$ = next.handle(req);

    return this.cacheEnabled && ttl
      ? this.wrap$(
          cacheKey,
          next$.pipe(map(event => (event instanceof HttpResponse ? serializeHttpResponse(event) : null))),
          ttl
        ).pipe(map(data => createHttpResponse(data)))
      : next$;
  }
}
